export default "skymp5-front/34d7c23d97684ec11c66319566850bee.svg";